const server={
  // url: "https://apiportalmanager.mayaland.store" //PRODUCCION V1
  url: "https://backv2.portalmanager.pro" // BACKEND V2 PRODUCCION
  // url: "http://localhost:4800" // LOCAL
}

export const elixir={
  url:"https://portalmanager.pro"
}
export default server
